import React, { useEffect, useState } from 'react'
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Popover,
  useMediaQuery,
  Theme,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import clsx from 'clsx'
import { str } from '../../../utils'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

const InfoPopover: React.FC<{
  info?: string
  anchorOrigin?: void
  transformOrigin?: void
}> = ({ anchorOrigin = {}, transformOrigin = {}, info }): JSX.Element => {
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  return (
    <>
      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
        {info && (
          <Box flex="0 0 auto" mt="-7px" ml={sm ? '0px' : '45px'}>
            <IconButton
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              color="primary"
              onClick={handlePopoverOpen}
              tabIndex={-1}
            >
              <InfoOutlinedIcon style={{ color: '#6C6C6C', fontSize: 25 }} />
            </IconButton>
            <Popover
              disableRestoreFocus
              id="mouse-over-popover"
              open={open}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
                ...anchorOrigin,
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
                ...transformOrigin,
              }}
            >
              <Box px="22px" pt="15px" pb="18px">
                {str.normalize(info, true)}
              </Box>
            </Popover>
          </Box>
        )}
      </Box>
    </>
  )
}

export const CheckListItem: React.FC<{
  index: number
  list: any
  handleChangeList: (data: any) => void
  disableList: boolean
  className: any
  img: any
}> = ({ index = 0, list = [], handleChangeList = () => {}, className, img = [], disableList = false }): JSX.Element => {
  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const [all, setAll] = useState<any>({
    1: true,
  })

  const handleChangeExAll = (id: number, show: boolean) => {
    setAll({ ...all, [id]: show })
  }

  const [sub, setSub] = useState<any>({})

  const handleChangeExSub = (id: number, show: boolean) => {
    setSub({ ...sub, [id]: show })
  }

  const handleChange = (data: any) => {
    handleChangeList(data)
  }

  useEffect(() => {}, [])

  const check = {
    icon: <span className={className.iconCheck} />,
    checked: (
      <span className={className.iconCheck}>
        <Box className={className.check} />
      </span>
    ),
  }

  return (
    <>
      {list && (
        <Accordion
          key={`list${index}`}
          expanded={all[`${list.id}`]}
          onChange={() => handleChangeExAll(list.id, !all[`${list.id}`])}
          square={false}
        >
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>{list.name}</AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetailsQuiz}>
              {list.checklists &&
                list.checklists.map((quiz: any, indexQuiz: number) => {
                  return (
                    <Box key={`list${indexQuiz}`} mt={1}>
                      <Grid container wrap="nowrap" justifyContent="space-between" alignItems="flex-start">
                        <Grid item xs={11}>
                          <FormControl disabled={disableList}>
                            <Grid
                              container
                              wrap={quiz.type === 'ONE' || quiz.type === 'TEST' ? (sm ? 'wrap' : 'nowrap') : 'wrap'}
                              justifyContent="flex-start"
                              alignItems="center"
                              spacing={2}
                            >
                              <Grid item xs={quiz.type === 'ONE' || quiz.type === 'TEST' ? (sm ? 11 : 8) : 12}>
                                <Box
                                  className={clsx({
                                    [className.labelLevel2]: quiz.level === 2,
                                    [className.labelLevel3]: quiz.level === 3,
                                  })}
                                >
                                  <FormLabel>{quiz.name}</FormLabel>
                                </Box>
                              </Grid>
                              <Grid item xs={quiz.type === 'ONE' || quiz.type === 'TEST' ? 'auto' : 12}>
                                {(quiz.type === 'ONE' || quiz.type === 'TEST' || (sm && quiz.type === 'MULTIPLE')) && (
                                  <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                                    {quiz.variants &&
                                      quiz.variants.map((variants: any, indexVariants: number) => {
                                        return (
                                          <Grid
                                            item
                                            key={`list${indexVariants}`}
                                            xs={quiz.type === 'ONE' || quiz.type === 'TEST' ? 'auto' : sm ? 12 : 6}
                                          >
                                            <RadioGroup
                                              key={index}
                                              value={variants.answer}
                                              onChange={(e) => {
                                                handleChange({
                                                  varsId: e.target.value,
                                                  variantsId: variants.id,
                                                  quizId: quiz.id,
                                                })
                                              }}
                                            >
                                              <Box ml={1}>
                                                <Grid
                                                  container
                                                  wrap="nowrap"
                                                  justifyContent="flex-start"
                                                  alignItems="center"
                                                  spacing={1}
                                                >
                                                  {quiz.type === 'MULTIPLE' && variants.vars.length > 1 && (
                                                    <Grid key={variants.id} item>
                                                      <Box className={className.numQuiz}>{variants.id}. </Box>
                                                    </Grid>
                                                  )}
                                                  {variants.vars &&
                                                    variants.vars.map((vars: any, indexVars: number) => {
                                                      return (
                                                        <Grid key={`list${indexVars}`} item>
                                                          <FormControlLabel
                                                            name={`${vars.id}`}
                                                            value={`${vars.id}`}
                                                            disabled={disableList}
                                                            control={
                                                              <Radio
                                                                color="secondary"
                                                                disabled={disableList}
                                                                checked={variants.answer === vars.id}
                                                                checkedIcon={check.checked}
                                                                icon={check.icon}
                                                              />
                                                            }
                                                            label={`${vars.name}`}
                                                          />
                                                        </Grid>
                                                      )
                                                    })}
                                                </Grid>
                                              </Box>
                                            </RadioGroup>
                                          </Grid>
                                        )
                                      })}
                                  </Grid>
                                )}

                                {!sm && quiz.type === 'MULTIPLE' && (
                                  <Grid container justifyContent="flex-start" alignItems="center">
                                    <Grid item xs={6}>
                                      <Grid
                                        container
                                        direction="column"
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                        spacing={1}
                                      >
                                        <Grid item>
                                          {quiz.variants &&
                                            quiz.variants.map((variants: any, indexVariants: number) => {
                                              // if (Math.ceil(quiz.variants.length / 2) > indexVariants) {
                                              return (
                                                <Grid
                                                  item
                                                  key={`list${indexVariants}`}
                                                  xs={
                                                    quiz.type === 'ONE' || quiz.type === 'TEST' ? 'auto' : sm ? 12 : 6
                                                  }
                                                >
                                                  <RadioGroup
                                                    key={index}
                                                    value={variants.answer}
                                                    onChange={(e) => {
                                                      handleChange({
                                                        varsId: e.target.value,
                                                        variantsId: variants.id,
                                                        quizId: quiz.id,
                                                      })
                                                    }}
                                                  >
                                                    <Box ml={1}>
                                                      <Grid
                                                        container
                                                        wrap="nowrap"
                                                        justifyContent="flex-start"
                                                        alignItems="center"
                                                        spacing={1}
                                                      >
                                                        {quiz.type === 'MULTIPLE' && variants.vars.length > 1 && (
                                                          <Grid key={variants.id} item>
                                                            <Box className={className.numQuiz}>{variants.id}. </Box>
                                                          </Grid>
                                                        )}
                                                        {variants.vars &&
                                                          variants.vars.map((vars: any, indexVars: number) => {
                                                            return (
                                                              <Grid key={`list${indexVars}`} item>
                                                                <FormControlLabel
                                                                  name={`${vars.id}`}
                                                                  value={`${vars.id}`}
                                                                  disabled={disableList}
                                                                  control={
                                                                    <Radio
                                                                      color="secondary"
                                                                      disabled={disableList}
                                                                      checked={variants.answer === vars.id}
                                                                      checkedIcon={check.checked}
                                                                      icon={check.icon}
                                                                    />
                                                                  }
                                                                  label={`${vars.name}`}
                                                                />
                                                              </Grid>
                                                            )
                                                          })}
                                                      </Grid>
                                                    </Box>
                                                  </RadioGroup>
                                                </Grid>
                                              )
                                              // } else return <></>
                                            })}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    {/* <Grid item xs={6}> */}
                                    {/*  <Grid */}
                                    {/*    container */}
                                    {/*    direction="column" */}
                                    {/*    justifyContent="flex-start" */}
                                    {/*    alignItems="flex-start" */}
                                    {/*    spacing={1} */}
                                    {/*  > */}
                                    {/*    <Grid item> */}
                                    {/*      {quiz.variants && */}
                                    {/*        quiz.variants.map((variants: any, indexVariants: number) => { */}
                                    {/*          if (indexVariants > Math.ceil(quiz.variants.length / 2 - 1)) { */}
                                    {/*            return ( */}
                                    {/*              <Grid */}
                                    {/*                item */}
                                    {/*                key={`list${indexVariants}`} */}
                                    {/*                xs={ */}
                                    {/* eslint-disable-next-line max-len */}
                                    {/*                  quiz.type === 'ONE' || quiz.type === 'TEST' ? 'auto' : sm ? 12 : 6 */}
                                    {/*                } */}
                                    {/*              > */}
                                    {/*                <RadioGroup */}
                                    {/*                  key={index} */}
                                    {/*                  value={variants.answer} */}
                                    {/*                  onChange={(e) => { */}
                                    {/*                    handleChange({ */}
                                    {/*                      varsId: e.target.value, */}
                                    {/*                      variantsId: variants.id, */}
                                    {/*                      quizId: quiz.id, */}
                                    {/*                    }) */}
                                    {/*                  }} */}
                                    {/*                > */}
                                    {/*                  <Box ml={1}> */}
                                    {/*                    <Grid */}
                                    {/*                      container */}
                                    {/*                      wrap="nowrap" */}
                                    {/*                      justifyContent="flex-start" */}
                                    {/*                      alignItems="center" */}
                                    {/*                      spacing={1} */}
                                    {/*                    > */}
                                    {/* eslint-disable-next-line max-len */}
                                    {/*                      {quiz.type === 'MULTIPLE' && variants.vars.length > 1 && ( */}
                                    {/*                        <Grid key={variants.id} item> */}
                                    {/* eslint-disable-next-line max-len */}
                                    {/*                          <Box className={className.numQuiz}>{variants.id}. </Box> */}
                                    {/*                        </Grid> */}
                                    {/*                      )} */}
                                    {/*                      {variants.vars && */}
                                    {/*                        variants.vars.map((vars: any, indexVars: number) => { */}
                                    {/*                          return ( */}
                                    {/*                            <Grid key={`list${indexVars}`} item> */}
                                    {/*                              <FormControlLabel */}
                                    {/*                                name={`${vars.id}`} */}
                                    {/*                                value={`${vars.id}`} */}
                                    {/*                                disabled={disableList} */}
                                    {/*                                control={ */}
                                    {/*                                  <Radio */}
                                    {/*                                    color="secondary" */}
                                    {/*                                    disabled={disableList} */}
                                    {/*                                    checked={variants.answer === vars.id} */}
                                    {/*                                    checkedIcon={check.checked} */}
                                    {/*                                    icon={check.icon} */}
                                    {/*                                  /> */}
                                    {/*                                } */}
                                    {/*                                label={`${vars.name}`} */}
                                    {/*                              /> */}
                                    {/*                            </Grid> */}
                                    {/*                          ) */}
                                    {/*                        })} */}
                                    {/*                    </Grid> */}
                                    {/*                  </Box> */}
                                    {/*                </RadioGroup> */}
                                    {/*              </Grid> */}
                                    {/*            ) */}
                                    {/*          } else return <></> */}
                                    {/*        })} */}
                                    {/*    </Grid> */}
                                    {/*  </Grid> */}
                                    {/* </Grid> */}
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                          </FormControl>
                        </Grid>
                        <Grid item xs={1}>
                          <InfoPopover info={quiz.info} />
                        </Grid>
                      </Grid>
                    </Box>
                  )
                })}

              <Box id="sub-group" className={className.subGroup}>
                {list.subGroup &&
                  list.subGroup.length > 0 &&
                  list.subGroup.map((subGroup: any, indexSub: number) => {
                    return (
                      <Accordion
                        key={`sub_group${indexSub}`}
                        expanded={sub[`${subGroup.id}`]}
                        onChange={() => handleChangeExSub(list.id, !sub[`${subGroup.id}`])}
                        square={false}
                      >
                        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
                          {subGroup.name}
                        </AccordionSummary>
                        <AccordionDetails>
                          <Box className={className.subGroupAccordionDetailsBox}>
                            {subGroup.checklists &&
                              subGroup.checklists.map((quizSub: any, indexQuizSub: number) => {
                                return (
                                  <Box key={`sub_group${indexQuizSub}`} mt={quizSub.id === 1 ? 0 : 2}>
                                    <Grid
                                      container
                                      wrap="nowrap"
                                      justifyContent="space-between"
                                      alignItems="flex-start"
                                    >
                                      <Grid item xs={11}>
                                        <FormControl disabled={disableList}>
                                          <Grid
                                            container
                                            wrap={sm ? 'wrap' : 'nowrap'}
                                            justifyContent="flex-start"
                                            alignItems="center"
                                            spacing={2}
                                          >
                                            <Grid item xs={sm ? 11 : 8}>
                                              <Box
                                                className={clsx({
                                                  [className.labelLevel2]: quizSub.level === 2,
                                                  [className.labelLevel3]: quizSub.level === 3,
                                                })}
                                              >
                                                <FormLabel>{quizSub.name}</FormLabel>
                                              </Box>
                                            </Grid>
                                            <Grid item xs="auto">
                                              {quizSub.variants &&
                                                quizSub.variants.map((variantsSub: any, indexVariantsSub: number) => {
                                                  return (
                                                    <RadioGroup
                                                      key={`sub_group${indexVariantsSub}`}
                                                      value={variantsSub.answer}
                                                      onChange={(e) => {
                                                        handleChange({
                                                          varsId: e.target.value,
                                                          variantsId: variantsSub.id,
                                                          quizId: quizSub.id,
                                                        })
                                                      }}
                                                    >
                                                      <Grid
                                                        container
                                                        wrap="nowrap"
                                                        justifyContent="flex-start"
                                                        alignItems="center"
                                                      >
                                                        {variantsSub.vars &&
                                                          variantsSub.vars.map((varsSub: any, indexVarsSub: number) => {
                                                            return (
                                                              <Grid key={`sub_group${indexVarsSub}`} item>
                                                                <FormControlLabel
                                                                  name={`${varsSub.id}`}
                                                                  value={`${varsSub.id}`}
                                                                  disabled={disableList}
                                                                  control={
                                                                    <Radio
                                                                      color="secondary"
                                                                      disabled={disableList}
                                                                      checked={variantsSub.answer === varsSub.id}
                                                                      checkedIcon={check.checked}
                                                                      icon={check.icon}
                                                                    />
                                                                  }
                                                                  label={`${varsSub.name}`}
                                                                />
                                                              </Grid>
                                                            )
                                                          })}
                                                      </Grid>
                                                    </RadioGroup>
                                                  )
                                                })}
                                            </Grid>
                                          </Grid>
                                        </FormControl>
                                      </Grid>
                                      <Grid item xs={1}>
                                        <InfoPopover info={quizSub.info} />
                                      </Grid>
                                    </Grid>
                                  </Box>
                                )
                              })}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    )
                  })}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  )
}
